(ns frontend.view.components.account
  (:require
   [frontend.view.components.autocomplete :as autocomplete]
   [clojure.string :as string]
   [frontend.state.current-session :as session]
   [reagent.core :as r]
   [frontend.utils :as fu]
   [ui.components.button.view :as button]))

(defn member-circle
  [{:keys [account-id on-remove! tooltip-text]}]
  (let [entity (get @session/entities account-id)
        pic-url (:account/picture-url entity)]
    [button/secondary-open 
     {:tooltip tooltip-text}
     [:div
      {:class "h-10 w-10 border border-solid border-base-light-border-paler rounded-full relative group"}
      (when (and (not (session/is-read-only-user?))
                 (fn? on-remove!))
        [:span
         {:class "h-8 w-8 items-center justify-center absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 rounded-full bg-base-light hidden group-hover:flex"}
         [:i.fal.fa-trash-alt
          {:on-click on-remove!}]])
      (if pic-url
        [:span
         {:class "block w-full h-full rounded-full bg-cover bg-no-repeat bg-center"
          :style {:background-image (str "url('" pic-url "')")}}]
        [:span
         (string/trim (str (first (:account/first-name entity))
                           " "
                           (first (:account/last-name entity))))])]]))

(defn account-circle
  [account-id on-click! tooltip-text]
  (let [entity (get @session/entities account-id)
        pic-url (:account/picture-url entity)]

    [button/secondary-open 
     {:tooltip tooltip-text}
     [:div
      {:class "flex items-center justify-center w-12 h-12 border border-solid border-base-light-border rounded-full"
       :on-click (fn [e]
                   (.preventDefault e)
                   (.stopPropagation e)
                   (when on-click!
                     (on-click!)))}
      (if pic-url
        [:span
         {:class "block w-full h-full rounded-full bg-cover bg-no-repeat bg-center"
          :style {:background-image (str "url('" pic-url "')")}}]
        [:span
         (string/trim (str (first (:account/first-name entity))
                           " "
                           (first (:account/last-name entity))))])]]))

;; TODO: support images
(defn account-view
  [{:keys [value large? name? dimmed? on-click]}]
  (if-let [{:keys [account/first-name account/last-name]} value]
    [:div.oppo-field-account
     (if on-click {:on-click on-click})
     [:span.oppo-field-account__image
      {:class (str (if large? "oppo-field-account__image--large")
                   " "
                   (if-not value "oppo-field-account__image--hidden")
                   " "
                   (if dimmed? "oppo-field-account__image--dimmed"))}
      (str (first first-name) (first last-name))]
     (if name?
       [:div.oppo-field-account-name
        [:span.oppo-field-account-name__span.oppo-field-account-name__span--bold
         first-name]
        [:span.oppo-field-account-name__span last-name]])]))

(defn single-account-view
  [{:keys [label value accounts large? name? edit? on-change]}]
  (let [account (-> (filter (fn [account]
                              (= value (:db/id account)))
                            accounts)
                    first)
        view (fn [{:keys [value]}]
               [account-view
                {:value   value
                 :large?  large?
                 :name?   name?
                 :dimmed? false}])]
    [:div.oppo-field
     [:label.oppo-field__label label]
     [:div.oppo-field-content.oppo-field-content--less-padding
      (if edit?
        [autocomplete/autocomplete
         {:value            account
          :on-change        (fn [new-account]
                              (on-change (:db/id new-account)))
          :key-fn           :db/id
          :search-fn        (fn [input set-results!]
                              (let [input (string/lower-case input)]
                                (->> accounts
                                     (filter
                                      (fn [{:keys [account/first-name account/last-name]}]
                                        (or (string/starts-with? (string/lower-case first-name) input)
                                            (string/starts-with? (string/lower-case last-name) input))))
                                     set-results!)))
          :value-component  view
          :result-component view}]
        [view {:value account}])]]))
